import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CheckoutDetails } from '../models/checkoutDetails';

type CheckoutDetailsState = {
    checkoutDetails?: CheckoutDetails;
};

const checkoutDetailsInitialState: CheckoutDetailsState = {};

const navigation = createSlice({
    name: 'checkoutIdDetails',
    initialState: checkoutDetailsInitialState,
    reducers: {
        setCheckoutDetails: (
            state: CheckoutDetailsState,
            action: PayloadAction<CheckoutDetails>,
        ) => {
            state.checkoutDetails = action.payload;
        },
        clearCheckoutDetails: (state: CheckoutDetailsState) => {
            state.checkoutDetails = undefined;
        }
    },
});

export const { setCheckoutDetails, clearCheckoutDetails } =
    navigation.actions;

export default navigation.reducer;
